import React, { Component } from 'react'; 
import { AuthContext } from '../../../auth/AuthHandler';
import { ReleaseTrackerDataService } from '../../../data/ReleaseTrackerDataService';
import { BackButton, ProductCard } from './../../../components/index'
import './Peripherals.css';

export default class Peripherals extends Component{
  
  static contextType = AuthContext

  constructor(props) {
    super(props)
    this.state = {
      data: null,
    };
  }
  
  componentDidMount() {
    this.relTrackerService = new ReleaseTrackerDataService(this.context);
    this.relTrackerService.getFirmwareFamilies("peripherals")
      .then(data => {
        this.setState({
          data: data,
        })
      })
      .catch(err => {
        console.error(err);
      });
  }

  render(){
    return(
      <div className="peripherals">
        <BackButton />
        <div className="cards">
          {this.state.data && this.state.data.map(value => (
            <ProductCard key={value.Name} title={value.Name} url={{pathname:'peripherals/'+value.Name, data: value}} img={value.Name}/>
          ))}
        </div>
      </div>
    )
  }
}
